import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import * as Config from "./serverConfig";

// ---- Event list ----

export const getMaintainEventList = createAsyncThunk(
  "maintain/getEventList",
  async (props) => {
    const link = Config.Server?.link + "mode=getMaintainEventList";
    const params = new URLSearchParams();
    params.append("id", props.id);
    params.append("from", props.from);
    params.append("to", props.to);

    const response = await axios({
      method: "post",
      url: link,
      data: params,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    const json = await response.data;

    if (json.success) {
      return json.data.map((item, idx) => ({
        ...item,
        id: `event_${item.truckID}_${item.created}_${idx}`,
      }));
    }
    return { success: false, message: json.message };
  }
);

// ---- Device summary ----

export const getMaintainDeviceSummary = createAsyncThunk(
  "maintain/getDeviceSummary",
  async (props) => {
    const link = Config.Server?.link + "mode=getMaintainDeviceSummary";
    const params = new URLSearchParams();
    params.append("id", props.id);
    params.append("from", props.from);
    params.append("to", props.to);

    const response = await axios({
      method: "post",
      url: link,
      data: params,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    const json = await response.data;

    if (json.success) {
      return json.data.map((item) => ({
        ...item,
        id: item.DeviceID,
      }));
    }
    return { success: false, message: json.message };
  }
);

// Store both thunk results in one slice. No adapter needed; reports.js reads via
// applyReportPayload which accepts a plain array payload.
const Slice = createSlice({
  name: "maintainReport",
  initialState: {
    eventList: [],
    deviceSummary: [],
  },
  reducers: {},
  extraReducers: {
    [getMaintainEventList.fulfilled]: (state, action) => {
      state.eventList = Array.isArray(action.payload) ? action.payload : [];
    },
    [getMaintainDeviceSummary.fulfilled]: (state, action) => {
      state.deviceSummary = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export default Slice.reducer;
